module.exports = __webpack_public_path__ + "media/images/icon-op-b57dc58c1adffe404ff0eea4ed6e1ad8.svg";